export class ListAzureSubnetsRequest {
    'resourceGroup';
    'virtualNetworkName';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceGroup",
            "baseName": "resourceGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "virtualNetworkName",
            "baseName": "virtualNetworkName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureSubnetsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
